import { useGraphQLQuery } from '@betterment/js-runtime';

import { SignablePackageQueryResult } from './data';
import { QuerySignablePackageDocument } from './graphql/query.signable_package.generated';

export const useSignablePackageQuery = (signablePackageId: string): SignablePackageQueryResult => {
  const { data } = useGraphQLQuery(QuerySignablePackageDocument, {
    throwOnError: true,
    variables: { signablePackageId },
  });

  const isLoading = !data;

  return {
    isLoading,
    signablePackage: data?.signablePackage,
  };
};
